import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useEffect, useMemo, useState } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import usePreOrder from '~/hooks/vdp/cta/usePreOrder';
import { ListenerEvent, type ListenerEventType } from './constants';

type StartPreOrderPayload = {};

function isStartPreOrderMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, StartPreOrderPayload> {
  return message.event === ListenerEvent.StartPreOrder;
}

export default function useStartPreOrderHandler(): MessageHandler<
  ListenerEventType,
  StartPreOrderPayload
> {
  const [shouldStartPreOrder, setShouldStartPreOrder] = useState(false);
  const preOrder = usePreOrder();
  const {
    rcbPurchasing: { isLoaded: isPurchasingLoaded }
  } = useContext(UserVehicleContext);

  useEffect(() => {
    if (!shouldStartPreOrder || !isPurchasingLoaded) return;

    void preOrder();
    setShouldStartPreOrder(false);
  }, [isPurchasingLoaded, preOrder, shouldStartPreOrder]);

  return useMemo(
    () =>
      new MessageHandler(isStartPreOrderMessage, () => {
        setShouldStartPreOrder(true);
      }),
    []
  );
}
